import { structuredTheme } from 'ia-react-core';
import { AppTheme } from '../interfaces/Theme';

const appTheme: AppTheme = {
  ...structuredTheme,
  layout: {
    ...structuredTheme.layout,
    maxContentWidth: 100000,
  },
  Modal: {
    ...structuredTheme.Modal,
    background: '#fff',
    closeButtonBackground: 'transparent',
    closeButtonHoverBackground: 'transparent',
    closeButtonActiveBackground: 'transparent',
  },
};

export default appTheme;
